/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:15 PM
 *
 */

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useMemberTestList } from 'features/members/api/query/useMemberTestList';
import { useTestList } from 'features/members/api/query/useTestList';
import { Member, Test } from 'features/members/types';
import { getChartData } from 'features/members/utils/getChartData';

import { TestLineChart } from 'components/LineChart';
/* import { TestLineChart } from '@/components/charts/LineChart';
import { ProfileTestTab } from '@/modules/members/components/tests/ProfileTestTab';*/
import Loader from 'components/Loader';
import { ProfileTestDropdown } from 'features/members/components/dropdown/ProfileTestDropdown';
import { ProfileTestTab } from 'features/members/components/others/TestTab/TestTab';

interface IProfileTestSection {
  selectedMember: Member;
}

const Tab = ({ selectedMember }: IProfileTestSection) => {
  const [params] = useSearchParams();
  const { isLoading, data: testList } = useTestList();
  const [selectedTest, setSelectedTest] = useState({} as Test);

  useEffect(() => {
    testList && setSelectedTest(testList[0]);
  }, [testList]);

  const { data: testDetailsList, isLoading: testLoading } = useMemberTestList(
    selectedMember.id,
    Number(selectedTest?.id),
    Number(params.get('page') ?? 1)
  );

  const chartData = testDetailsList ? getChartData(testDetailsList.list) : {};

  return (
    <div className="relative flex w-full flex-col rounded-2xl bg-white p-8 shadow-sm">
      {!isLoading ? (
        <div className="print:hidden">
          <div className="flex flex-col space-y-8 sm:space-y-4">
            <div className=" flex items-center justify-between sm:flex-col sm:items-start sm:gap-4">
              <div className="print:hidden">
                <h1 className="text-3xl font-medium tracking-wider text-gray-900 sm:text-2xl">
                  Tests
                </h1>
                <h1 className="text-lg font-medium text-gray-500 print:hidden">
                  Please choose a test to show results of that test
                </h1>
              </div>
              {testList && (
                <ProfileTestDropdown
                  testList={testList}
                  selectedTest={selectedTest}
                  setSelectedTest={setSelectedTest}
                />
              )}
            </div>
            <div className="space-y-4">
              {testLoading ? (
                <Loader />
              ) : (
                <>
                  {Object.keys(chartData).length !== 0 && <TestLineChart datas={chartData} />}
                  <ProfileTestTab testList={testDetailsList} selectedMember={selectedMember} />
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default React.memo(Tab);
